import { gql } from 'graphql-tag';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

const getEvaluaciones = gql`
  query Query($idPlantilla: Int) {
    evaluaciones(idPlantilla: $idPlantilla) {
      id
      fechaContable
      idPlantilla
      idInstitucion
    }
  }
`;
const getDetalleEvaluacionCuenta = gql`
  query Query($idEvaluacion: Int) {
    detalleEvaluacionCuentas(idEvaluacion: $idEvaluacion) {
      idCuenta
      idEvaluacion
      valor
    }
  }
`;
const getCuentas = gql`
  query Query($idPlantilla: Int) {
    cuentas(idPlantilla: $idPlantilla) {
      id
      descripcion
      idPlantilla
    }
  }
`;
const getDetalleEvaluacionVariables = gql`
  query DetalleEvaluacionVariable($idEvaluacion: Int) {
    detalleEvaluacionVariables(idEvaluacion: $idEvaluacion) {
      idEvaluacion
      idVariable
      valor
    }
  }
`;
const getVariables = gql`
  query DetalleEvaluacionVariable($idPlantilla: Int) {
    variables(idPlantilla: $idPlantilla) {
      id
      descripcion
      idPlantilla
    }
  }
`;
const getDetalleEvaluacionVariableTem = gql`
  query DetalleEvaluacionVariable($idEvaluacion: Int) {
    detalleEvaluacionVarsTemps(idEvaluacion: $idEvaluacion) {
      idEvaluacion
      idVarTemp
      valor
    }
  }
`;
const getVariableTem = gql`
  query DetalleEvaluacionVariable($idPlantilla: Int) {
    varsTemp(idPlantilla: $idPlantilla) {
      descripcion
      id
      idPlantilla
    }
  }
`;


export { getEvaluaciones, getDetalleEvaluacionCuenta, getCuentas, getDetalleEvaluacionVariables, getVariables, getDetalleEvaluacionVariableTem, getVariableTem }